import React, { ReactNode } from 'react'
import { Accordion } from '@base-ui/react/accordion'
import './ExpandableSection.scss'

interface ExpandableSectionProps {
  label: string
  children: ReactNode
  variant?: 'push' | 'accordion'
  className?: string
  onToggle?: (expanded: boolean) => void
  listClassName?: string
  toggleClassName?: string
}

export const ExpandableSection = ({
  label,
  children,
  variant = 'accordion',
  className,
  onToggle,
  listClassName,
  toggleClassName
}: ExpandableSectionProps) => {
  const rootClass = ['expandable-section', `expandable-section--${variant}`, className].filter(Boolean).join(' ')

  const header = (
    <Accordion.Header render={<div />}>
      <Accordion.Trigger className={`expandable-section__toggle ${toggleClassName || ''}`}>
        <span>{label}</span>
        <span className='expandable-section__icon' aria-hidden='true' />
      </Accordion.Trigger>
    </Accordion.Header>
  )

  const panel = (
    <Accordion.Panel className='expandable-section__content'>
      <div className={`expandable-section__content-inner ${listClassName || ''}`}>{children}</div>
    </Accordion.Panel>
  )

  return (
    <Accordion.Root className={rootClass} keepMounted>
      <Accordion.Item onOpenChange={(open) => onToggle?.(open)}>
        {variant === 'push' ? <>{panel}{header}</> : <>{header}{panel}</>}
      </Accordion.Item>
    </Accordion.Root>
  )
}
